// http://grsmto.github.io/simplebar/
Vue.component("TKTextScroll", {
    template: `
        <div class="TKTextScroll">
            <slot></slot>
        </div>
    `,
    mounted () {
        this.simpleBar = new SimpleBar(this.$el);
    },

    destroyed () {
        if(this.simpleBar) this.simpleBar.unMount();
    }
})